module.exports = __webpack_public_path__ + "media/images/email_banner-7db76092e42ec4dd337fe1a621ca2875.png";